import http from './http'

export function getMyProfile () {
  return http.get('/users/me').then(function (res) {
    return res.data
  })
}

export function updateProfile (payload) {
  return http.patch('/users/me', payload).then(function (res) {
    return res.data
  })
}

/**
 * Get a 15-minute presigned PUT URL for uploading an avatar.
 * The server generates the full object key from the filename.
 * @param {string} filename  Original filename including extension, e.g. "profile.jpg"
 * @returns {Promise<{ objectKey: string, url: string }>}
 */
export function getAvatarUploadUrl (filename) {
  return http.get('/users/me/avatar-upload-url', { params: { filename: filename } }).then(function (res) {
    return res.data
  })
}

export function confirmAvatarUpload (objectKey) {
  return http.post('/users/me/avatar', { objectKey: objectKey }).then(function (res) {
    return res.data
  })
}
